module.exports = __webpack_public_path__ + "static/media/chhola.13f93a52.jpg";